import React from 'react'
import { Footer } from '../../organims/footer'
import { PersonalInfo } from '../../organims/personalInfo'

export const Home = () => (
  <>
    <PersonalInfo />
    <Footer />
  </>
)
